// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Facebook: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
            <g fill="none" fillRule="evenodd">
                <circle cx="22" cy="22" r="21.5" stroke="#FFF" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M34.5 22.573c0-6.67-5.371-12.073-12-12.073s-12 5.404-12 12.073c0 6.026 4.388 11.02 10.125 11.927v-8.437h-3.048v-3.49h3.048v-2.66c0-3.025 1.79-4.697 4.532-4.697 1.314 0 2.687.236 2.687.236v2.97H26.33c-1.49 0-1.955.93-1.955 1.885v2.266h3.328l-.532 3.49h-2.796V34.5c5.737-.906 10.125-5.901 10.125-11.927Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Facebook);
